import Header from "./components/Header";
import Home from "./components/Home";

function App() {
  return (
    <div className=" items-center justify-center w-full h-[100vh]">
      <Header />
      <Home />
    </div>
  );
}
export default App;
